<template>
    <q-modal v-model="visible" @show="$refs.input.focus()" ref="modal" :content-css="{width: '500px'}">
        <div class="q-pa-lg">
            <h1>Новый клиент</h1>
            <form autocomplete="off" novalidate @submit.prevent="save" method="post">
                <q-field>
                    <q-input float-label="Имя" type="text" v-model="user.first_name" ref="input"
                             :error="$v.user.first_name.$error" :disable="isFieldsDisabled" />
                </q-field>
                <q-field>
                    <q-input float-label="Фамилия" type="text" v-model="user.last_name"
                             :error="$v.user.last_name.$error" :disable="isFieldsDisabled"/>
                </q-field>
                <q-field>
                  <q-input
                      float-label="Электронная почта"
                      type="email"
                      v-model="user.email"
                      @blur="searchUserByEmail"
                      :error="$v.user.email.$error"
                  />
                </q-field>
                <q-field>
                    <q-input float-label="Телефон" type="text" v-model="user.phone_number"
                             :error="$v.user.phone_number.$error" :disable="isFieldsDisabled"/>
                </q-field>
                <q-field v-if="$auth.check('root')">
                    <q-select float-label="Роль" v-model="user.role" :options="roles"/>
                </q-field>
                <q-field>
                    <q-input float-label="Пароль" type="password" v-model="user.password"
                              :disable="isFieldsDisabled"/>
                </q-field>
                <input v-model="user.horoshop_id" type="hidden" />
                <div class="row justify-end q-mt-md">
                    <q-btn label="Создать" :loading="loading" type="submit" color="primary" class="q-mr-xs"/>
                    <q-btn label="Отмена" @click="hideModal" color="primary" flat/>
                </div>
            </form>
        </div>
    </q-modal>
</template>

<script>
  import columnsValues from '@/HTable/columnsValues';
  
  import {
    QModal,
    QField,
    QInput,
    QSelect,
    QBtn,
  } from 'quasar';

  import {
    required,
    email,
    numeric
  } from 'vuelidate/lib/validators';

  export default {
    name: 'UserCreate',
    components: {
      QModal,
      QField,
      QInput,
      QSelect,
      QBtn
    },
    data() {
      return {
        user: {
          id: null,
          first_name: '',
          last_name: '',
          email: '',
          phone_number: null,
          password: null,
          type: 'INDIVIDUAL',
          role: 'user',
          horoshop_id: null
        },
        roles: columnsValues.roles,
        loading: false,
        isFieldsDisabled: true,
      }
    },
    validations: {
      user: {
        first_name: {required},
        last_name: {required},
        email: {required, email},
        phone_number: {required},
      }
    },
    props: {
      value: Boolean,
      redirect: Boolean
    },
    computed: {
      visible: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val);
        }
      }
    },
    watch: {
      visible(val) {
        //if ()
        //this.$emit('input', val);
      },
      'user.role'(newRole, oldRole) {
        if ((oldRole === 'user' && newRole !== 'user') || (newRole === 'user' && oldRole !=='user')) {
          this.user.id = null;
          this.user.first_name = '';
          this.user.last_name = '';
          this.user.phone_number = null;
          this.user.horoshop_id = null;
          this.user.password = null;
          this.$v.user.$reset();
        }
        this.isFieldsDisabled = newRole === 'user';
      }
    },
    created() {
      this.$parent.$on('setUserLastName', this.setUserLastName);
    },
    methods: {
      save() {
        this.loading = true;
        this.$v.user.$touch();
        if (this.$v.user.$error) {
          this.$q.notify('Please review fields again.');
          this.loading = false;
          return;
        }

        this.$http.post(`api/v1.0/users/`, this.user).then((response) => {
          this.user.id = this.getUserId(response.headers.location);
          if (this.redirect) {
            this.$router.push(`/users/${this.user.id}`);
          } else {
            this.hideModal();
            this.loading = false;
            this.$q.notify({message: 'Пользователь создан', type: 'positive'});
          }
          this.$emit('create', this.user);
          this.resetUserData();
        }).catch(error => {
          this.loading = false;
          _.forIn(error.response.data.errors, (value, key) => {
            this.$q.notify({message: value[0], type: 'negative'});
          });
        });
      },
      searchUserByEmail() {
        if (this.user.role !== 'user') {
          return;
        }
        if (this.user.email) {
          this.$http.get(`/api/v1.0/horoshopid/users/${this.user.email}`).then(response => {
            const foundUser = response.data;
            if (foundUser && foundUser.horoshop_id) {
              this.user.first_name = foundUser.first_name;
              this.user.last_name = foundUser.last_name;
              this.user.phone_number = foundUser.phone_number;
              this.user.horoshop_id = foundUser.horoshop_id;
            } else {
              this.$q.notify({message: 'User with such email was not found', type: 'negative'});
            }
          });
        }
      },
      hideModal() {
        this.$refs.modal.hide();
        this.$emit('close');
      },
      setUserLastName(value) {
        this.user.last_name = value.charAt(0).toUpperCase() + value.slice(1);
      },
      getUserId(headerLocation) {
        return headerLocation.split('users/')[1];
      },
      resetUserData () {
        this.user = {
          id: null,
          first_name: '',
          last_name: '',
          email: '',
          phone_number: null,
          password: null,
          type: 'INDIVIDUAL',
          role: 'user',
          horoshop_id:  null
        };
        this.$v.user.$reset();
      }
    }
  }
</script>






// WEBPACK FOOTER //
// resources/assets/js/components/UserCreate/UserCreate.vue